
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';
import { DLSettings, settingsToUpdateInput } from './model';

const SettingsQuery = require('./gql/settings.query.gql');
const updateDLSettingsMutation = require('./gql/update-settings.mutation.gql');

@Injectable()
export class DLSettingsService {

  constructor(private apollo: Apollo) { }

  settings(): Observable<DLSettings> {
    return this.apollo
      .query({
        query: SettingsQuery,
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['dlSettings']));
  }

  updateSettings(settings: DLSettings): Observable<DLSettings> {
    return this.apollo
      .mutate({
        mutation: updateDLSettingsMutation,
        variables: {
          input: settingsToUpdateInput(settings),
        }
      }).pipe(
      map(result => result.data['updateDLSettings']));
  }
}
